import { SET_ERROR } from "../actions/errorActions";
import ErrorState from "../stateTypes/errorState";

const initialState: ErrorState = {
    error: null,
};

const errorReducer = (state: ErrorState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_ERROR:
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
};

export default errorReducer;
